import { jsx } from 'react/jsx-runtime';
import { useMemo, useCallback } from 'react';
import { useQueryTags } from '../queries/useQueryTags.js';
import { MultiSelect } from '@fabric-app/ui/components/MultiSelect/MultiSelect';
import { IconDropdown14TagTilt } from '@fabric-app/icons/svg';
import { useInputControls } from '@fabric-app/hooks/useInputControls';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';

const defaultValue = [];
const MultiselectTags = ({ value = defaultValue, onChange, disabled = false }) => {
  const { data: tags, isLoading } = useQueryTags();
  const { isMobileView } = useResponsive();
  const options = useMemo(() => {
    const res = (tags || [])?.map((tag) => ({
      value: tag.id,
      label: tag.name,
      stringLabel: tag.name
    })) || [];
    res.unshift({
      value: "placeholder",
      label: "Any tag",
      stringLabel: "Any tag"
    });
    return res;
  }, [
    tags
  ]);
  const searchInputControls = useInputControls();
  const filterDisplayedOption = useCallback((option) => {
    return option.stringLabel.toLowerCase().includes(searchInputControls.sanitizedValue.toLowerCase());
  }, [
    searchInputControls.sanitizedValue
  ]);
  const valueExistingOnly = useMemo(() => {
    return value.filter((v) => !!options.find((o) => o.value === v));
  }, [
    value,
    options
  ]);
  return /* @__PURE__ */ jsx(MultiSelect, {
    title: "Filter by tag...",
    trigger: {
      icon: /* @__PURE__ */ jsx(IconDropdown14TagTilt, {}),
      testId: "filters-tag-button",
      disabled
    },
    searchProps: {
      value: searchInputControls.value,
      onChange: searchInputControls.onChange,
      placeholder: isMobileView ? "Search for a tag" : "Type any tag"
    },
    filterDisplayedOption,
    isLoading,
    options,
    value: valueExistingOnly,
    onValueChange: onChange
  });
};

export { MultiselectTags };
//# sourceMappingURL=MultiselectTags.js.map
